import Options from "../../options";

/** Base URL for Koneko budget + access API (microservice or main nekoapi). */
export function getKonekoBudgetApiBaseUrl() {
  const env = String(
    process.env.VUE_APP_KONEKO_BUDGET_API_BASE_URL || ""
  ).trim();
  if (env) return env.endsWith("/") ? env : `${env}/`;
  const api = String(process.env.VUE_APP_API_BASE_URL || "").trim();
  if (api) return api.endsWith("/") ? api : `${api}/`;
  return Options.useDevServer ? Options.devServerUrl : Options.prodServerUrl;
}
